import { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";
import AdditionalPin from "../../assets/icons/Additional";
import JsonRender from "../JsonRender";

type IProps = {
  title: string;
  description?: string;
  explanation: IConfig[];
  open?: boolean;
  onClick?: () => void;
};

const AdditionalNote = ({
  title,
  explanation,
  description,
  open,
  onClick,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(open || false);
  const btnRef = useRef<any>();

  useEffect(() => {
    if (open !== undefined) {
      setIsOpen(open);
    }
  }, [open]);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    if (onClick) {
      onClick();
    }
  };

  return (
    <Box bg={"neutral.950"} px="1rem" py="1rem">
      <Button
        leftIcon={<AdditionalPin color="whiteAlpha.800" />}
        variant="outline"
        ref={btnRef}
        onClick={handleOpen}
      >
        {title}
      </Button>

      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={handleClose}
        finalFocusRef={btnRef}
        size="md"
      >
        <DrawerOverlay />
        <DrawerContent bg={"neutral.950"}>
          <DrawerCloseButton />
          <DrawerHeader>{description}</DrawerHeader>

          <DrawerBody bg={"neutral.950"}>
            <JsonRender mode="view" content={explanation} />
          </DrawerBody>

          <DrawerFooter>
            <Button
              variant="secondary"
              size="lg"
              mr={{ base: 0, md: 3 }}
              width={{ base: "full", md: "fit-content" }}
              onClick={handleClose}
            >
              Back to lesson
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

export default AdditionalNote;
